export const CONTENT_DATA_PATH_SERVICE = '/services/content/v1/data';
export const USER_LOGIN_PATH_SERVICE = '/services/user/v2/ott/login';
export const USER_ISLOGGEDIN_SERVICE_PATH = '/services/user/v2/ott/isloggedin';
export const CONTENT_RECOMMENDATIONS_PATH_SERVICE =
  '/services/content/v1/recommendations';
export const USER_LOGOUT_PATH_SERVICE = '/services/user/v1/ott/logout';
export const SEARCH_LINEAL_PREDICTIVE = 'services/search/v1/linealpredictive';
export const CMS_LEVEL_PATH_SERVICES = '/services/cms/v2/level';
export const CMS_LEVEL_USER_PATH_SERVICES = '/services/cms/v2/leveluser';
export const CONTENT_LIST_PATH_SERVICES = '/services/content/v1/list';
export const CMS_SUPERHIGHLIGHT_PATH_SERVICES =
  '/services/cms/v1/superhighlight';
export const USER_SEEN_PATH_SERVICES = '/services/user/v1/seen';
export const FAVORITE_USER_PATH_SERVICES = '/services/user/v1/favorited';
export const RECORDING_LIST_PATH_SERVICES = '/services/recordings/v1/list';
export const PURCHASE_ACTIVE_PATH_SERVICES =
  '/services/user/v1/purchasedactive';
export const WORKFLOWSTART_PATH_SERVICE = '/services/payway/v1/workflowstart';
export const PURCHASE_NODE_ID_PATH_SERVICES = `/services/payway/paymentservice/v1/purchasednodeid/`;
export const MULTI_PBI_PATH_SERVICES =
  '/services/payway/paymentservice/v2/multipurchasebuttoninfo';
export const MULTI_CONTENT_SEARCH_PATH_SERVICES =
  '/services/payway/paymentservice/v1/multicontentsearch';
export const PURCHASE_BUTTON_INFO_PATH_SERVICE =
  '/services/payway/v2/purchasebuttoninfo';
export const GET_LASTTOUCH_PATH_SERVICE = '/services/user/v1/lasttouch/get';
export const SERVICES_USER_REGISTER_PATH_SERVICES =
  '/services/user/v1/register';
export const PAYWAY_V1_LINEALCHANNELS_PATH_SERVICE =
  '/services/payway/v1/linealchannels';
export const USER_CHANNELS_SEEN_PATH = '/services/user/v3/livechannel';
export const EPG_EVENTS_BY_GENRE_PATH = '/services/epg/v2/bygenre';
export const USER_RECOMMENDATIONS = '/services/user/v1/recommendation';
